module.exports = __webpack_public_path__ + "img/7.cd362b1f.png";